import { render, staticRenderFns } from "./SynthesisOfAlumChemicalFormula.vue?vue&type=template&id=acc3eb30&"
import script from "./SynthesisOfAlumChemicalFormula.vue?vue&type=script&lang=ts&"
export * from "./SynthesisOfAlumChemicalFormula.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
